import { Dispatch, FC, SetStateAction, useCallback } from 'react';
import { twMerge } from 'tailwind-merge';
import { Pagination } from './Pagination';
import { PrevNextButton } from './PrevNextButton';

type TablePaginationProps = {
  limit: number;
  currentPage: number;
  totalAmount: number;
  onPageClick: Dispatch<SetStateAction<number>>;
  className?: string;
};

export const TablePagination: FC<TablePaginationProps> = ({ limit, currentPage, totalAmount, onPageClick, className }) => {
  const totalPages = Math.ceil(totalAmount / limit);
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;

  const goToPreviousPage = useCallback(() => {
    onPageClick((prev) => prev - 1);
  }, [onPageClick]);

  const goToNextPage = useCallback(() => {
    onPageClick((prev) => prev + 1);
  }, [onPageClick]);

  return (
    <div className={twMerge('flex items-center justify-between gap-4', className)}>
      <PrevNextButton type='previous' onClick={goToPreviousPage} disabled={isFirstPage || totalAmount === 0} />
      <Pagination currentPage={currentPage} totalPages={totalPages} onPageClick={onPageClick} />
      <PrevNextButton type='next' onClick={goToNextPage} disabled={isLastPage || totalAmount === 0} />
    </div>
  );
};
